import { render, staticRenderFns } from "./PromocodeDeleteModal.vue?vue&type=template&id=2f6dc604&scoped=true"
import script from "./PromocodeDeleteModal.vue?vue&type=script&lang=js"
export * from "./PromocodeDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./PromocodeDeleteModal.vue?vue&type=style&index=0&id=2f6dc604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6dc604",
  null
  
)

export default component.exports